"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var Tooltip_1 = __importDefault(require("@material-ui/core/Tooltip"));
var Typography_1 = require("../Typography");
exports.default = react_1.forwardRef(function Tooltip(_a, ref) {
    var title = _a.title, rest = __rest(_a, ["title"]);
    if (typeof title === 'string') {
        title = jsx_runtime_1.jsx(Typography_1.P, { children: title }, void 0);
    }
    return jsx_runtime_1.jsx(Tooltip_1.default, __assign({ title: title, ref: ref }, rest), void 0);
});
//# sourceMappingURL=Tooltip.js.map